/** Promotion Service **/
(function() {

	// add the service
	SUGApp.service('promotionService', promotionService);

	promotionService.$inject = [ 'SUGUtilities','globalService','$q' ];
	function promotionService(   SUGUtilities, globalService, $q ){

		//define a service object to return
		var service = {

			//start data calls
			determineUserCoupon: function (data) {
				return SUGUtilities.APISyncCall('post', '', data, 'c.determineUserCoupon', 15000);
			},

			getUserInfoForPromo: function (data, testQueryString) {
				if (testQueryString) {
					return SUGUtilities.APISyncCall('post', '', data, 'c.getUserInfoForPromo&'+testQueryString, 15000);
				}
				return SUGUtilities.APISyncCall('post', '', data, 'c.getUserInfoForPromo', 15000);
			},

			getMemberInfoShortbyEmail: function (data) {
				return SUGUtilities.APISyncCall('post', '', data, 'm.getMemberInfoShortbyEmail', 15000);
			},

			updateUserPrizeClaim: function (data) {
				return SUGUtilities.APISyncCall('post', '', data, 'c.updateUserPrizeClaim', 15000);
			},

			processNewsletterOptIn: function (data) {
				return SUGUtilities.APISyncCall('post', '', data, 'c.processNewsletterOptIn', 15000);
			},
			
			getActivePromo: function (data) {
				return SUGUtilities.APISyncCall('post', '', data, 'c.getActivePromo', 15000);
			}			

		};   // END service

		//return the object
		return service;
	}

}());